import { createWebRegistration } from '@reflex/plugin-api/create-web-registration';
import { OpenCodeIcon } from './icons/OpenCodeIcon';

export default createWebRegistration({
  icons: {
    OpenCodeIcon,
  },
});
